/**
 * When the open project's DocStore appeared in this tab (W2-10 projects-data): history entries older than that come
 * from an earlier session (history survives reload) and sit below the History panel's "opened" divider.
 */

import type { DocStore } from '../../state/types';

const started = new WeakMap<DocStore, number>();

/** Records that `store` is in use from now on (first call wins). */
export function noteSession(store: DocStore, at: number = Date.now()): void {
  if (!started.has(store)) started.set(store, at);
}

/** Epoch ms when this tab started using `store` (recorded on first use). */
export function sessionStart(store: DocStore): number {
  noteSession(store);
  return started.get(store) ?? Date.now();
}
